import { BulkUpdateFieldType } from "components/BulkUpdateOptionalFieldsModal/types";
import {
  buildScanLabelPayload,
  ScanLabelSelector,
} from "components/BulkUpdateOptionalFieldsModal/ScanLabelSelector";
import { UpdateInformationScanLabels } from "components/BulkUpdateOptionalFieldsModal/UpdateInformationScanLabels";

export const ScanLabelFields: BulkUpdateFieldType[] = [
  {
    fieldName: "addLabels",
    Component: ScanLabelSelector,
    componentProps: {},
    UpdateInformationComponent: UpdateInformationScanLabels,
    emptyValue: null,
    buildPayload: buildScanLabelPayload,
  },
  {
    fieldName: "removeLabels",
    Component: ScanLabelSelector,
    componentProps: {},
    UpdateInformationComponent: UpdateInformationScanLabels,
    emptyValue: null,
  },
];
